import { FileUploaderProps } from "@/types/components/FileUploaderProps";
import { Dialog, Transition } from "@headlessui/react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Fragment, useState } from "react";
import MediaContent from "./MediaContent";
import InputError from "@/Components/InputError";

const FileUploader = ({
    label = 'Dodaj film',
    icon = 'ic:round-local-movies',
    className= '',
    setData,
    data, 
    fileKey,
    disk = 'movies',
    errors,
    acceptedFormats = 'image/*,.docx,.pdf,.odt,.xls,.xlsx,.mp4,.mp3,.mov,.webm,.avi'
}: FileUploaderProps) => {
    const [activePopup, setActivePopup] = useState<boolean>(false);

    const closeLibrary = () => {
        setActivePopup(false);
    }

    return (
        <div className={className}>
            <div className="border-1 border-dashed border-royalPeriwinkle py-8 flex flex-wrap items-center justify-center px-3">
                <button onClick={() => setActivePopup((prev) => !prev)} type="button" className="rounded py-3 px-6 font-semibold inline-flex gap-x-2 items-center text-center text-arcticMist bg-gradientButton text-16 leading-6 transition-theme hover:enabled:shadow-buttonHover focus:bg-accordorange focus-visible:bg-accordorange">
                    <Icon icon={icon} width={24} />
                    {label}
                </button>
                {data[fileKey] &&
                    <p className="text-14 leading-18 w-full text-accordorange text-center mt-6 font-semibold">Wybrano plik: {data[fileKey]}</p>
                }
            </div>
            <InputError message={errors[fileKey]}/>
            <Transition show={activePopup} as={Fragment} leave="duration-200">
                <Dialog
                    as="div"
                    id="modal"
                    className={`fixed inset-0 flex overflow-y-auto px-4 py-6 sm:px-0 items-center z-50 transform transition-all`}
                    onClose={close}
                >
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className={`absolute inset-0 bg-midnightAbyss/80`} />
                    </Transition.Child>

                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >

                        <Dialog.Panel
                            className={`mb-6 bg-gradientPopup h-[90%] max-w-[calc(100vw_-_12%)] w-full no-scrollbar p-4 shadow-popupEffect rounded-[16px] overflow-hidden transform transition-all sm:w-full sm:mx-auto`}
                        >
                            <div className='flex justify-end mb-2'>
                                <button type='button' onClick={() => setActivePopup(false)}>
                                    <Icon icon={`ic:round-close`} className='text-arcticMist' width={24} />
                                </button>
                            </div>
                            <div className="content px-8 pb-8 h-full">
                                <MediaContent setData={setData} fileKey={fileKey} closeLibrary={closeLibrary} disk={disk} acceptedFormats={acceptedFormats}/>
                            </div>
                        </Dialog.Panel>
                    </Transition.Child>
                </Dialog>
            </Transition>
        </div>
    )
}

export default FileUploader;